<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Others Info</v-expansion-panel-title
                            >
                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addEmployee"
                                id="addEmployee"
                                >
                                <v-row class="pa-2">
                                    <v-col cols="12">
                                        <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="sale_order_master_id.value.value"
                                            :items="getSaleOrderList"
                                            :item-title="(item) => `${item.code}`"
                                            item-value="id"
                                            @update:modelValue="onSaleInvoiceChange"
                                            :error-messages="sale_order_master_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            multiple
                                            chips
                                            :loading="saleOrderLoading"
                                        >
                                            <template #label>
                                                Sales Orders
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-date-input
                                            label="Delivery Date"
                                            density="compact"
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="delivery_date.value.value"
                                            :error-messages="delivery_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        ></v-date-input>

                                        <!-- <v-autocomplete
                                            variant="outlined"
                                            density="compact"
                                            bg-color="grey-lighten-4"
                                            v-model="warehouse_id.value.value"
                                            :items="getWarehouseList"
                                            :item-title="(item) => `${item.name}`"
                                            item-value="id"
                                            :error-messages="warehouse_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                Warehouse
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete> -->

                                        <v-text-field 
                                            label="Container No"
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="container_no.value.value"
                                            :error-messages="container_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                        <template #label>
                                               Container No
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-text-field>

                                        <v-text-field
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            label="MBL No"
                                            v-model="mbl_no.value.value"
                                            :error-messages="mbl_no.errorMessage.value"
                                            autocomplete="off" 
                                        ></v-text-field>

                                        <v-text-field
                                            label="HBL No"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="hbl_no.value.value"
                                            :error-messages="hbl_no.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                        </v-text-field>

                                        <v-date-input
                                            prepend-icon=""
                                            prepend-inner-icon="mdi-calendar"
                                            label="MBL / HBL Date"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="mbl_date.value.value"
                                            :error-messages="mbl_date.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                                MBL / HBL Date
                                            </template>
                                        </v-date-input>

                                        <v-autocomplete 
                                            variant="outlined" 
                                            density="compact"
                                            bg-color="grey-lighten-4" 
                                            v-model="customer_id.value.value"
                                            @update:model-value="onCustomerChange"
                                            :items="getCustomerMapList"
                                            :item-title="(item) => (item && item.customer) ? `${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''} - ${item.customer.code} - ${item.customer.customer_type.name}` : ''"
                                            item-value="customer_id"
                                            :error-messages="customer_id.errorMessage.value"
                                            autocomplete="off" 
                                            clearable
                                            class="d-none"
                                            >
                                            <template #label>
                                                Buyer Name
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                        </v-autocomplete>

                                        <v-autocomplete 
                                            label="Shipment Mode" 
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="shipment_mode.value.value"
                                            :items="[{ name: 'by_sea', display_text: 'By Sea' }, { name: 'by_road', display_text: 'By Road' }, { name: 'by_air', display_text: 'By Air' }]"
                                            :item-title="(item) => `${item.display_text}`" 
                                            item-value="name"
                                            :error-messages="shipment_mode.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            class="d-none"
                                        >
                                        </v-autocomplete>

                                         <v-autocomplete 
                                            label="Port of Loading" 
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="from_port_id.value.value"
                                            :items="getPortList"
                                            :item-title="(item) => `${item?.name}`" 
                                            item-value="id"
                                            @update:model-value="onFromPortChange"
                                            :error-messages="from_port_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                               Port of Loading
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                            <template v-slot:selection="{ props, item }">
                                                <div class="d-flex align-center noto-color-emoji-regular"
                                                    v-bind="props"
                                                    color="primary"
                                                    variant="tonal"
                                                >
                                                <span v-if="item?.raw" style="font-size: 14px; margin-top: 10px;">
                                                    {{ item?.raw.name }}, 
                                                    {{ item?.raw.country?.name }}
                                                    <span class="noto-color-emoji-regular">{{ item?.raw.country?.emoji }}</span>
                                                </span>
                                                </div>
                                            </template>
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" v-slot=""  :title="null">
                                                    <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                        <div class="flex-grow-1">
                                                            <span>{{ item?.raw.name }}</span>
                                                        </div>
                                                        <div class="text-grey text-caption">
                                                            {{ item?.raw.country.name }}
                                                            <span class="mr-2 text-lg noto-color-emoji-regular">{{ item?.raw.country.emoji }}</span>
                                                        </div>
                                                    </div>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>

                                        <v-autocomplete 
                                            label="Port of Destination" 
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="to_port_id.value.value"
                                            :items="getPortList"
                                            :item-title="(item) => `${item.name}`" 
                                            @update:model-value="onToPortChange"
                                            item-value="id"
                                            :error-messages="to_port_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                        >
                                            <template #label>
                                               Port of Destination
                                                <span class="text-red-accent-4">*</span>
                                            </template>
                                            <template v-slot:selection="{ props, item }">
                                                <div class="d-flex align-center noto-color-emoji-regular"
                                                    v-bind="props"
                                                    color="primary"
                                                    variant="tonal"
                                                >
                                                <span v-if="item?.raw" style="font-size: 14px; margin-top: 10px;">
                                                    {{ item?.raw.name }}, 
                                                    {{ item?.raw.country?.name }}
                                                    <span class="noto-color-emoji-regular">{{ item?.raw.country?.emoji }}</span>
                                                </span>
                                                </div>
                                            </template>
                                            <template v-slot:item="{ props, item }">
                                                <v-list-item v-bind="props" v-slot=""  :title="null">
                                                    <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                        <div class="flex-grow-1">
                                                            <span>{{ item?.raw.name }}</span>
                                                        </div>
                                                        <div class="text-grey text-caption">
                                                            {{ item?.raw.country.name }}
                                                            <span class="mr-2 text-lg noto-color-emoji-regular">{{ item?.raw.country.emoji }}</span>
                                                        </div>
                                                    </div>
                                                </v-list-item>
                                            </template>
                                        </v-autocomplete>

                                        <v-text-field 
                                            label="Commodity" 
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="commodity.value.value"
                                            :error-messages="commodity.errorMessage.value" 
                                            autocomplete="off"
                                            clearable
                                            class="d-none"
                                            >
                                        </v-text-field>

                                        <v-autocomplete 
                                            label="Shipper Name"
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="supplier_id.value.value"
                                            :items="getCustomerMapList"
                                            @update:model-value="onSupplierChange"
                                            :item-title="(item) => (item && item.customer) ? `${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''} - ${item.customer.code} - ${item.customer.customer_type.name}` : ''"                                              
                                            item-value="customer_id"
                                            :error-messages="supplier_id.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            class="d-none"
                                        >
                                        </v-autocomplete>

                                        <v-autocomplete 
                                            label="Sales Order By"
                                            density="compact"
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            :items="getBrandList"
                                            v-model="sales_by.value.value"
                                            disabled
                                            :item-title="item => item && item.name"                                                  
                                            item-value="id"
                                            :error-messages="sales_by.errorMessage.value"
                                            autocomplete="off"
                                            clearable
                                            class="d-none"
                                        >
                                        </v-autocomplete>

                                        <v-autocomplete 
                                            label="Currency"
                                            density="compact" 
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            :items="getLatestExchangeRateList"
                                            v-model="rate_id.value.value"
                                            disabled
                                            :item-title="item => item && item.currency_name"                                                                                                   
                                            item-value="id"
                                            :error-messages="rate_id.errorMessage.value"
                                            @update:model-value="onCurrencyChange"
                                            autocomplete="off"
                                            clearable
                                            class="d-none"
                                        >
                                        </v-autocomplete>

                                        <v-text-field
                                            label="Currency Rate"
                                            density="compact" 
                                            variant="outlined" 
                                            bg-color="grey-lighten-4"
                                            v-model="currency_rate.value.value"
                                            :error-messages="currency_rate.errorMessage.value" 
                                            autocomplete="off"
                                            :disabled="true" clearable
                                            class="d-none"
                                        >
                                        </v-text-field>

                                        <v-text-field
                                            label="Sale Order Delivered By"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                            class="d-none"
                                        ></v-text-field>

                                        <v-text-field
                                            label="Sale Order Delivered By Mobile"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="requsition_by_mobile.value.value"
                                            :error-messages="requsition_by.errorMessage.value"
                                            autocomplete="off"
                                            :disabled="true"
                                            clearable
                                            class="d-none"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                            color="blue-grey-lighten-4"
                            class="panel-header"
                            >
                                Item Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form
                                @submit.prevent="submit"
                                ref="addDelivery"
                                id="addDelivery"
                                >
                                    <v-row>
                                        <v-col class="mt-3">
                                            <v-table
                                                density="compact"
                                                :loading="orderDetailsLoading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="min-height: 40vh;"
                                            >
                                            <thead>
                                                <!-- <tr>
                                                    <td colspan="8" class=""></td>
                                                    <td colspan="4" class="text-center bg-orange-lighten-4">CTN/BAG QTY/ KG</td>
                                                </tr> -->
                                                <tr>
                                                    <th style="width: 5%">SL</th>
                                                    <th class="d-none" style="min-width: 200px">CHALLAN NO</th>
                                                    <th style="min-width: 200px">ORDER NO</th>
                                                    <th style="min-width: 200px">BUYER</th>
                                                    <th style="min-width: 200px">SHIPMENT MODE</th>
                                                    <th style="min-width: 200px">SHIPPER NAME</th>
                                                    <th style="min-width: 200px">PRODUCT NAME</th>
                                                    <th style="min-width: 150px">CATEGORY</th>
                                                    <th style="min-width: 150px">CALC TYPE</th>
                                                    <!-- <th style="min-width: 120px">L (cm)</th>
                                                    <th style="min-width: 120px">W (cm)</th>
                                                    <th style="min-width: 120px">H (cm)</th> -->
                                                    <th style="min-width: 120px">CBM MEAS.</th>
                                                    <th style="min-width: 150px">ORDER QTY</th>
                                                    <th style="min-width: 150px">DELIVERY QTY</th>
                                                    <!-- <th style="min-width: 150px">Remaining QTY</th> -->
                                                    <!-- <th style="min-width: 150px">Already Delivered QTY</th> -->
                                                    <th style="min-width: 120px">PRODUCT QTY</th>
                                                    <th style="min-width: 120px">CBM</th>
                                                    <th style="min-width: 120px">RATE</th>
                                                    <th style="min-width: 150px">AMOUNT</th>
                                                    <th style="min-width: 200px">REMARKS</th>
                                                    <!-- <th style="min-width: 100px">ACTION</th> -->
                                                </tr>
                                                </thead>
                                                <tbody >
                                                    <tr v-for="(detail, index) in cart" :key="index">
                                                        <td class="text-center py-2">{{ index + 1 }}</td>
                                                        <td class="py-2 d-none">
                                                            <v-text-field
                                                            density="compact"
                                                            variant="outlined"
                                                            v-model="detail.challan_no"
                                                            disabled
                                                            label="Challan No"
                                                            type="text"
                                                            autocomplete="off"
                                                            hide-details
                                                            readonly
                                                            class=""
                                                        />
                                                        </td>
                                                         <td class="py-2">
                                                            <v-text-field
                                                            density="compact"
                                                            variant="outlined"
                                                            v-model="detail.order_no"
                                                            disabled
                                                            label="Order No"
                                                            type="text"
                                                            autocomplete="off"
                                                            hide-details
                                                            readonly
                                                            class=""
                                                        />
                                                        </td>
                                                        <td class="py-2">
                                                            <v-autocomplete 
                                                                variant="outlined" 
                                                                density="compact"
                                                                bg-color="grey-lighten-4" 
                                                                v-model="detail.customer_id"
                                                                :items="getCustomerMapList"
                                                                :item-title="(item) => (item && item.customer) ? `${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''} - ${item.customer.code} - ${item.customer.customer_type.name}` : ''"
                                                                item-value="customer_id"
                                                                autocomplete="off" 
                                                                readonly=""
                                                                disabled
                                                                hide-details
                                                            >
                                                                <template #label>
                                                                    Buyer Name
                                                                    <span class="text-red-accent-4"></span>
                                                                </template>

                                                            </v-autocomplete>
                                                        </td>
                                                        <td class="py-2">
                                                            <v-autocomplete 
                                                                label="Shipment Mode" 
                                                                density="compact"
                                                                variant="outlined" 
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.shipment_mode"
                                                                :items="[{ name: 'by_sea', display_text: 'By Sea' }, { name: 'by_road', display_text: 'By Road' }, { name: 'by_air', display_text: 'By Air' }]"
                                                                :item-title="(item) => `${item.display_text}`" 
                                                                item-value="name"
                                                                autocomplete="off"
                                                                readonly
                                                                disabled
                                                                hide-details
                                                            >
                                                            </v-autocomplete>
                                                        </td>
                                                        <td class="py-2">
                                                            <v-autocomplete 
                                                                label="Shipper Name"
                                                                density="compact"
                                                                variant="outlined" 
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.supplier_id"
                                                                :items="getCustomerMapList"
                                                                @update:model-value="onSupplierChange"
                                                                :item-title="(item) => (item && item.customer) ? `${item.customer.customer_name ? item.customer.customer_name : item.customer.customer_owner_name ? item.customer.customer_owner_name : ''} - ${item.customer.code} - ${item.customer.customer_type.name}` : ''"                                              
                                                                item-value="customer_id"
                                                                autocomplete="off"
                                                                readonly
                                                                disabled
                                                                hide-details
                                                            >
                                                            </v-autocomplete>
                                                        </td>
                                                        <td class="py-2">
                                                            <v-autocomplete
                                                                density="compact"
                                                                variant="outlined"
                                                                v-model="detail.product_id"
                                                                :items="getProductMapList"
                                                                :item-title="(item) => `${item.product?.name}`"
                                                                item-value="product_id"
                                                                label="Product"
                                                                autocomplete="off"
                                                                readonly
                                                                disabled
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'product_id')"
                                                                @blur="validateDetailField(index, 'product_id', detail.product_id)"
                                                            >
                                                                <template #append-item>
                                                                    <v-list-item v-if="search && !productExists" @click="createNewProduct(search)">
                                                                        <v-list-item-title>
                                                                            ➕ Add "<strong>{{ search }}</strong>" as new product
                                                                        </v-list-item-title>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-autocomplete>
                                                            
                                                        </td>
                                                       <td class="py-2">
                                                            <v-select
                                                                density="compact"
                                                                variant="outlined"
                                                                :items="[{title:'Brand', value:'brand'}, {title:'Non-Copy', value:'non_copy'}, {title:'Normal Copy', value:'normal_copy'}, {title:'Copy & Brand', value:'copy_and_brand'}]"
                                                                v-model="detail.category"
                                                                label="Category"
                                                                hide-details
                                                                autocomplete="off"
                                                                disabled
                                                                :error-messages="getDetailError(index, 'category')"
                                                                @blur="validateDetailField(index, 'category', detail.category)"
                                                            />
                                                        </td>

                                                        <td class="py-2" style="width: 160px">
                                                            <v-select
                                                                density="compact"
                                                                variant="outlined"
                                                                :items="[{title:'CBM', value:'cbm'}, {title:'Carton/Bag', value:'ctn'}, {title:'KG', value:'kg'}]"
                                                                v-model="detail.calc_type"
                                                                label="Calc"
                                                                autocomplete="off"
                                                                hide-details
                                                                disabled
                                                                @update:model-value="calculateRow(detail)"
                                                            />
                                                        </td>

                                                        <!-- <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                v-model="detail.length"
                                                                disabled
                                                                label="L"
                                                                type="number"
                                                                autocomplete="off"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                v-model="detail.width"
                                                                disabled
                                                                label="W"
                                                                type="number"
                                                                autocomplete="off"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                            />
                                                        </td>
                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                v-model="detail.height"
                                                                disabled
                                                                label="H"
                                                                type="number"
                                                                autocomplete="off"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                            />
                                                        </td> -->

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.cbm_meas"
                                                                disabled
                                                                label="CBM MEAS."
                                                                autocomplete="off"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'cbm_meas')"
                                                                @blur="validateDetailField(index, 'cbm_meas', detail.cbm_meas)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.order_qty"
                                                                label="Order Qty"
                                                                
                                                                readonly
                                                                disabled=""
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'order_qty')"
                                                                @blur="validateDetailField(index, 'order_qty', detail.qty)"
                                                                
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.qty"
                                                                label="Delivery Qty"
                                                                hide-details
                                                                readonly=""
                                                                disabled=""
                                                                :error-messages="getDetailError(index, 'qty')"
                                                                @blur="validateDetailField(index, 'qty', detail.qty)"
                                                            />
                                                        </td>

                                                         <!-- <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.remaining_qty"
                                                                label="Remaining Qty"
                                                                readonly
                                                                disabled=""
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'qty')"
                                                                @blur="validateDetailField(index, 'qty', detail.qty)"
                                                            />
                                                        </td> -->

                                                        <!-- <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.already_delivered_qty"
                                                                label="Already Delivered Qty"
                                                                readonly
                                                                disabled=""
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'already_delivered_qty')"
                                                                @blur="validateDetailField(index, 'already_delivered_qty', detail.already_delivered_qty)"
                                                            />
                                                        </td> -->

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.product_qty"
                                                                label="Product Qty"
                                                                hide-details
                                                                readonly=""
                                                                disabled=""
                                                                :error-messages="getDetailError(index, 'product_qty')"
                                                                @blur="validateDetailField(index, 'product_qty', detail.product_qty)"
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.cbm"
                                                                label="CBM"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                                :error-messages="getDetailError(index, 'cbm')"
                                                                @blur="validateDetailField(index, 'cbm', detail.cbm)"
                                                                readonly=""
                                                                disabled=""
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.rate"
                                                                label="Rate"
                                                                hide-details
                                                                @input="calculateRow(detail)"
                                                                :error-messages="getDetailError(index, 'rate')"
                                                                @blur="validateDetailField(index, 'rate', detail.rate)"
                                                                readonly=""

                                                                disabled=""
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                type="number"
                                                                v-model="detail.total"
                                                                label="Amount"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'total')"
                                                                @blur="validateDetailField(index, 'total', detail.total)"
                                                                readonly=""
                                                                disabled=""
                                                            />
                                                        </td>

                                                        <td class="py-2">
                                                            <v-text-field
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                v-model="detail.remarks"
                                                                label="Remarks"
                                                                hide-details
                                                                :error-messages="getDetailError(index, 'Total')"
                                                                @blur="validateDetailField(index, 'Total', detail.total)"
                                                            />
                                                        </td>

                                                        <!-- <td class="py-2">
                                                             <v-icon
                                                                @click="removeDetailRow(index)"
                                                                color="red"
                                                                icon="mdi-minus"
                                                                size="medium"
                                                                class="btn"
                                                            ></v-icon>
                                                            
                                                            <v-icon
                                                                @click="addDetailRow"
                                                                v-if="index == cart.length - 1"
                                                                color="info"
                                                                icon="mdi-plus"
                                                                size="medium"
                                                                class="ml-2"
                                                                disabled
                                                            ></v-icon>
                                                        </td> -->
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>


                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                        <v-col cols="8">
                                            <v-textarea
                                            label="Description"
                                            density="compact"
                                            variant="outlined"
                                            bg-color="grey-lighten-4"
                                            v-model="remarks.value.value"
                                            :error-messages="remarks.errorMessage.value"
                                            autocomplete="off"
                                            rows="3"
                                            clearable
                                            ></v-textarea>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-layout class="justify-end">
                                            <v-btn
                                            class="bg-grey-darken-1 me-2"
                                            variant="flat"
                                            @click="submitForm(0)"
                                            >DRAFT</v-btn>
                                            <v-btn
                                            class="bg-primary"
                                            variant="flat"
                                            @click="submitForm(1)"
                                            >POST</v-btn>
                                            </v-layout>
                                        </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref, reactive, getCurrentInstance } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";
import formattedDate from "@/plugins/dateFormatter";

export default {
    components: {},
    data: () => ({
        isEntryMode: true,
        saleOrderLoading:false,
        orderDetailsLoading:false,
        panel: [0],
        panel2: [0],
        loading: false,
        errorMessages: "",
        visible: false,
        deliveryQtyDisable: false,
        requisitionDisable: false,
        search: "",
        selectedImage: null,
        photo_imageFile: "",
        preview: "/src/assets/no_preview.png",
        cart: [],
        vatType: 'include',
        taxType: 'include',
        includeOrExclude: [
            { value: 'include', label: "Include" },
            { value: 'exclude', label: "Exclude" },
        ],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getBrandList.length === 0) {
            this.$store.dispatch("getBrandList");
        }
        if (this.$store.getters.getCustomerMapList.length === 0) {
            this.$store.dispatch("getCustomerMapList");
        }
        if (this.$store.getters.getSupplierMapList.length === 0) {
            this.$store.dispatch("getSupplierMapList");
        }
        if (this.$store.getters.getHrmDepartmentList.length === 0) {
            this.$store.dispatch("getHrmDepartmentList");
        }
        if (this.$store.getters.getWarehouseList.length === 0) {
            this.$store.dispatch("getWarehouseList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
        //if (this.$store.getters.getSaleOrderList.length === 0) {
            this.saleOrderLoading = true;
            this.$store.dispatch("getSaleOrderList",{
                isDel: true,
                edit_id: this.$route.query.id,
            }).then((res) => {
                this.saleOrderLoading = false;
            });
        //}
        if(this.$store.getters.getPortList.length === 0) {
            this.$store.dispatch('getPortList');
        }
        if (this.$store.getters.getLatestExchangeRateList.length == 0) {this.$store.dispatch('getLatestExchangeRateList')}
    },
    computed: {
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
        getCustomerMapList() {
            return this.$store.getters.getCustomerMapList;
        },
        getSupplierMapList() {
            return this.$store.getters.getSupplierMapList;
        },
        getPortList() {
            return this.$store.getters.getPortList;
        },
        getSaleOrderList() {
            return this.$store.getters.getSaleOrderList;
        },
        getBrandList() {
            return this.$store.getters.getBrandList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) =>
                item.branch_id == this.$store.getters.getAuthUser.branch_id &&
                item.status == 1
            );
        },
        getLatestExchangeRateList() {
            const rates = this.$store.getters.getLatestExchangeRateList || [];
            return rates.map(rate => ({
                ...rate,
                currency_name: rate.currency ? `${rate.currency.symbol} ${rate.currency.name} (${rate.currency.code})` : 'N/A'
            }));
        },
         subTotal() {
            return this.cart.reduce((sum, item) => +sum + +item.total, 0);
        },

        discountAmount() {
            if (!this.discount_value?.value.value) {
                this.discount_value.value.value = 0;
                this.discount_method.value.value = 'flat';
                return 0;
            } 

            const val = this.discount_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.discount_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        taxAmount() {
            if (!this.tax_value?.value.value) {
                this.tax_value.value.value = 0;
                this.tax_method.value.value = 'flat';
                return 0;
            } 

            const val = this.tax_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.tax_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        vatAmount() {
            if (!this.vat_value.value.value) {
                this.vat_value.value.value = 0;
                this.vat_method.value.value = 'flat';
                return 0;
            } 

            const val = this.vat_value.value.value.toString().trim();
            if (val.endsWith("%")) {
                this.vat_method.value.value = 'percent';
                const percentage = parseFloat(val.replace("%", ""));
                return (this.subTotal * percentage) / 100 || 0;
            }
            return parseFloat(val) || 0;
        },
        grandTotal() {
            const discount = this.discountAmount;
            const vat = this.vatType === 'include' ? this.vatAmount : 0;
            const tax = this.taxType === 'include' ? this.taxAmount : 0;
            return this.subTotal + vat + tax - discount;
        },
    },
    methods: {
        onChangePayReceived() {
            this.due.value.value = (parseFloat(this.grandTotal || 0)) - parseFloat(this.paid.value.value);
        },
        productCalculate(item) {
            if(item.qty > (+item.order_qty - +item.already_delivered_qty)) {
                item.qty = +item.order_qty - +item.already_delivered_qty 
            }
            item.remaining_qty = +item.order_qty - +item.already_delivered_qty - +item.qty;
            item.total = item.qty * item.rate
        },
        remainingQuantity(item) {
            if(!item.qty) {
                return item.available_qty - item.delivery_qty;
            } else if((item.available_qty - item.qty - item.delivery_qty) < 0){
                return 0;   
            } else {
                const totalSub = item.available_qty - item.qty - item.delivery_qty;
                return totalSub
            }
        },
        onCurrencyChange(id) {
            const list = this.$store.getters.getLatestExchangeRateList || [];
            let currency = list.find((it) => {
                return it.id == id;
            });
            if(currency) {
                this.currency_rate.value.value = currency.rate || "";

            } else {
                this.currency_rate.value.value = "";
            }
        },
        addCart() {
            let cartInd = this.cart.findIndex(
                (p) => p.product_id == this.product_id.value.value
            );

            if (this.product_id.value.value == null) {
                toast.error("Please select a Product");
                this.cartReset();
                return false;
            }

            if (cartInd > -1) {
                toast.error("Product already added in cart");
                this.cartReset();
                return false;
            }

            let product = this.getProductMapList.find(
                (item) => item.product_id == this.product_id.value.value
            );
            product = product.product;

            let item = {
                product_id: this.product_id.value.value,
                product_name: product.name,
                product_code: product.code,
                available_qty: product.available_inventory_qty,
                qty: 1,
                unit_id: product.unit_id,
                unit_name: product.unit.name,
            };
            this.cart.push(item);
            this.$nextTick(() => {
                this.cartReset();
            });
        },
        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },
        cartReset() {
            this.product_id.value.value = null;
        },

        async onSaleInvoiceChange(selectedId) {
            if (selectedId.length === 0) {
                this.warehouse_id.value.value = null;
                this.department_id.value.value = null;
                this.cart = []; // Clear cart when deselecting
                return;
            }

            try {
                this.orderDetailsLoading = true;
                const response = await this.$store.dispatch("getSaleOrderByIds", {sale_orders_id: selectedId});
                this.orderDetailsLoading = false;
                // this.customer_id.value.value = response.customer_id || "";
                // this.shipment_mode.value.value = response.shipment_mode || "";
                // this.from_port_id.value.value = response.from_port_id || "";
                // this.to_port_id.value.value = response.to_port_id || "";
                // this.rate_id.value.value = response.rate_id;
                // this.currency_rate.value.value = response.currency_rate;
                // this.sales_by.value.value = response.sales_by;
                // this.commodity.value.value = response.commodity || "";
                // this.supplier_id.value.value = response.supplier_id || "";
                
                this.cart = [];

                (response || []).forEach((order) => {
                    (order.details || []).forEach((item) => {
                        if (item.product) {
                            // if(+item.bag > +item.already_delivered_qty) {
                                this.cart.push({
                                    product_id: item.product_id,
                                    product_name: item.product.name || "",
                                    product_code: item.product.code || "",
                                    calc_type: item.calc_type || "",
                                    height: item.height || 0,
                                    width: item.width || 0,
                                    length: item.length || 0,
                                    category: item.category || "",
                                    order_qty: item.bag || 0,
                                    qty: item.bag || 0,
                                    remaining_qty: item.bag - item.already_delivered_qty,
                                    already_delivered_qty: item.already_delivered_qty,
                                    product_qty: item.qty || 0,
                                    cbm: item.cbm || 0,
                                    cbm_meas: item.cbm_meas || 0,
                                    rate: item.rate || "",
                                    total: item.total || "",
                                    remarks: item.remarks || "",

                                    sale_order_master_id: order?.id || null,
                                    sale_order_detail_id: item?.id || null,
                                    order_no: order?.code || "",
                                    challan_no: order?.chalan_no || "",
                                    receive_no: order?.receive_no || "",
                                    receive_date: order?.receive_date || "",
                                    customer_id: order?.customer_id || null,
                                    shipment_mode: order?.shipment_mode || null,
                                    supplier_id: order?.supplier_id || null,
                                    commodity: order?.commodity || "",
                                });
                            // }
                        }
                    });
                });

               
            } catch (error) {
                console.error("Error loading requisition:", error);
            }
        },
        async onCustomerChange(id) {
            if (!id) {
                // this.shop_name.value.value = "";
                // this.buyer_phone.value.value = "";
                return;
            }

            const list = this.$store.getters.getCustomerMapList || [];
            let entry = list.find((it) => {
                return it.customer_id == id || (it.customer && (it.customer.id == id || it.customer.customer_id == id));
            });

            let customer = entry ? entry.customer : null;

            if (!customer) {
                try {
                    customer = await this.$store.dispatch("getCustomerById", id);
                } catch (err) {
                    customer = null;
                }
            }

            if (customer) {
                // this.shop_name.value.value = customer.company_name || customer.company_owner_name || "";
                // this.buyer_phone.value.value = customer.mobile || customer.company_mobile || customer.company_phone || customer.phone || "";
            } else {
                // this.shop_name.value.value = "";
                // this.buyer_phone.value.value = "";
            }
        },

        async onSupplierChange(id) {
            if (!id) {
                // this.shipper_company_name.value.value = "";
                // this.shipper_phone.value.value = "";
                return;
            }

            // const list = this.$store.getters.getSupplierMapList || [];
            // let entry = list.find((it) => {
            //     return it.supplier_id == id || (it.supplier && (it.supplier.id == id || it.supplier.supplier_id == id));
            // });

            // let supplier = entry ? entry.supplier : null;

            // if (!supplier) {
            //     try {
            //         supplier = await this.$store.dispatch("getSupplierById", id);
            //     } catch (err) {
            //         supplier = null;
            //     }
            // }

            // if (supplier) {
                // this.shipper_company_name.value.value = supplier.company_name || supplier.company_owner_name || "";
                // this.shipper_phone.value.value = supplier.supplier_mobile || supplier.company_mobile || supplier.company_phone || supplier.phone || "";
            // } else {
                // this.shipper_company_name.value.value = "";
                // this.shipper_phone.value.value = "";
            // }
            const list = this.$store.getters.getCustomerMapList || [];
            let entry = list.find((it) => {
                return it.customer_id == id || (it.customer && (it.customer.id == id || it.customer.customer_id == id));
            });

            let customer = entry ? entry.customer : null;

            if (!customer) {
                try {
                    customer = await this.$store.dispatch("getCustomerById", id);
                } catch (err) {
                    customer = null;
                }
            }

            // if(customer) {
            //     this.shipper_company_name.value.value = customer.customer_name || customer.customer_owner_name || "";
            //     this.shipper_phone.value.value = customer.mobile || customer.customer_mobile || customer.customer_phone || customer.phone || "";
            // } else {
            //     this.shipper_company_name.value.value = "";
            //     this.shipper_phone.value.value = "";
            // }
        },

        onFromPortChange(val) {
            try { this.from_port_id.value.value = val; } catch (e) {}
            const toVal = this.to_port_id?.value?.value;
            if (val && toVal && val === toVal) {
                try { this.to_port_id.value.value = null; } catch (e) {}
                toast.error("Port of Loading and Port of Destination cannot be the same — destination cleared.");
            }
        },

        onToPortChange(val) {
            try { this.to_port_id.value.value = val; } catch (e) {}
            const fromVal = this.from_port_id?.value?.value;
            if (val && fromVal && val === fromVal) {
                try { this.from_port_id.value.value = null; } catch (e) {}
                toast.error("Port of Destination and Port of Loading cannot be the same — loading cleared.");
            }
        }
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                from_port_id: yup.number().positive().integer().required().label("Shipment From"),
                to_port_id: yup.number().positive().integer().required().label("Shipment To"),
                container_no: yup.string().trim().required().label("Container No"),
                // customer_id: yup.number().positive().integer().required().label("Buyer Name"),
                // supplier_id: yup.number().positive().integer().required().label("Shipper Name"),
                // requisition_date: yup.date().required().label("Requisition Date"),
                // require_date: yup.date().nullable().label("Require Date"),
                // department_id: yup.number().positive().integer().required().label("Department Name"),
                // warehouse_id: yup.number().positive().integer().required().label("Designation Name"),
                // sales_by: yup.number().positive().integer().required().label("Sales By"),
                // rate_id: yup.number().positive().integer().required().label("Currency"),
            }),
        });
        const invoice_delivery_master_id = useField("invoice_delivery_master_id");
        const product_id = useField("product_id");
        const pr_status = useField("pr_status");
        const detailErrors = reactive({});
        const status = useField("status");
        // const employee_id = useField("employee_id");
        const department_id = useField("department_id");
        const warehouse_id = useField("warehouse_id");
        const sale_order_master_id = useField("sale_order_master_id");

        const customer_id = useField("customer_id");
        const shipment_mode = useField("shipment_mode");
        const from_port_id = useField("from_port_id");
        const to_port_id = useField("to_port_id");
        const commodity = useField("commodity");
        const supplier_id = useField("supplier_id");

        const sales_by = useField("sales_by");
        const rate_id = useField("rate_id");
        const currency_rate = useField("currency_rate");
        const container_no = useField("container_no");
        const mbl_date = useField("mbl_date");
        const hbl_no = useField("hbl_no");
        const mbl_no = useField("mbl_no");

        const discount_value = useField("discount_value");
        const discount_method = useField("discount_method");
        const discount_amount = useField("discount_amount");
        const tax_amount = useField("tax_amount");
        const tax_value = useField("tax_value");
        const tax_type = useField("tax_type");
        const tax_method = useField("tax_method");
        const vat_amount = useField("vat_amount");
        const vat_value = useField("vat_value");
        const vat_type = useField("vat_type");
        const vat_method = useField("vat_method");

        const total = useField("total");
        const paid = useField('paid');
        const due = useField('due');

        const delivery_date = useField("delivery_date");
        const remarks = useField("remarks");
        const requsition_by = useField("requsition_by");
        const requsition_by_mobile = useField("requsition_by_mobile");
        const requsition_by_email = useField("requsition_by_email");
        const errorMessages = ref("");
         const cart = ref([
            {
                product_id: null,
                product_name: "",
                product_code: "",
                calc_type: "",
                height: "",
                width: "",
                length: "",
                category: "",
                order_qty: "",
                qty: "",
                remaining_qty: "",
                already_delivered_qty: "",
                product_qty: "",
                cbm_meas: "",
                cbm: "",
                rate: "",
                total: "",
                remarks: "",

                sale_order_master_id: null,
                sale_order_detail_id:null,
                order_no:"",
                challan_no: "",
                receive_no: "",
                receive_date: "",
                customer_id: null,
                shipment_mode: null,
                supplier_id: null,
                commodity: "",
                
            },
        ]);

        const addDetailRow = () => { 
            // cart.value.push({
            //     product_id: null,
            //     product_name: "",
            //     product_code: "",
            //     calc_type: "",
            //     height: "",
            //     width: "",
            //     length: "",
            //     category: "",
            //     order_qty: "",
            //     qty: "",
            //     remaining_qty: "",
            //     already_delivered_qty: "",
            //     product_qty: "",
            //     cbm_meas: "",
            //     cbm: "",
            //     rate: "",
            //     total: "",
            //     remarks: "",
            //     sale_order_master_id:null,
            //     sale_order_detail_id:null,
            //     order_no: "",
            //     challan_no: "",
            //     receive_no: "",
            //     receive_date: "",
            //     customer_id: null,
            //     shipment_mode: null,
            //     supplier_id: null,
            //     commodity: "",
            // });
        };

         const removeDetailRow = (index) => {
            if (cart.value.length > 1) {
                cart.value.splice(index, 1);
                delete detailErrors[index];
                const newErrors = {};
                Object.keys(detailErrors).forEach((key) => {
                const idx = parseInt(key);
                if (idx > index) {
                    newErrors[idx - 1] = detailErrors[key];
                } else if (idx < index) {
                    newErrors[idx] = detailErrors[key];
                }
                });
                Object.keys(detailErrors).forEach((key) => delete detailErrors[key]);
                Object.assign(detailErrors, newErrors);
            }
        };

        function calculateRow(row) {
            const bag = Number(row.bag) || 0;
            const qty = Number(row.qty) || 0;
            const rate = Number(row.rate) || 0;

            const L = Number(row.length) / 100 || 0;
            const W = Number(row.width) / 100 || 0;
            const H = Number(row.height) / 100 || 0;

            if (row.calc_type === "cbm") {
                row.cbm_meas = (L * W * H).toFixed(4);
                row.cbm = (row.cbm_meas * qty).toFixed(4);
                row.total = (row.cbm * rate).toFixed(2);
            }

            if (row.calc_type === "ctn") {
                row.cbm_meas = "";
                row.cbm = "";
                row.total = (qty * rate).toFixed(2);
            }

            if (row.calc_type === "kg") {
                row.cbm_meas = "";
                row.cbm = "";
                row.total = (qty * rate).toFixed(2);
            }
        };

        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();

        const currentStatus = ref(0);

        const validateDetailField = (index, field, value) => {
                if (!detailErrors[index]) {
                    detailErrors[index] = {};
                }

                detailErrors[index][field] = "";

                switch (field) {
                     case "product_id":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Product must be needed";
                        }
                        break;

                    case "category":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Category Name must be needed";
                        }
                        break;

                    case "qty":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Quantity must be needed";
                        }
                        break;

                    case "total":
                        if (!value || String(value).trim().length < 1) {
                            detailErrors[index][field] = "Total must be needed";
                        } 
                        break;
                }
        };

        const getDetailError = (index, field) => {
            return detailErrors[index] && detailErrors[index][field]
            ? [detailErrors[index][field]]
            : [];
        };

        const validateAllDetails = () => {
            let isValid = true;
            cart.value.forEach((detail, index) => {
                validateDetailField(index, "product_id", detail.product_id);
                // validateDetailField(index, "category", detail.category);
               validateDetailField(index, "qty", detail.qty);
                validateDetailField(index, "total", detail.total);
                if (detailErrors[index]) {
                    Object.values(detailErrors[index]).forEach((error) => {
                        if (error) isValid = false;
                    });
                }
            });

            return isValid;
        };

        const submitForm = (status) => {
            if (!validateAllDetails()) {
                toast.error("Please fix detail validation errors before submitting");
                return;
            }
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.delivery_date = formattedDate(delivery_date.value.value);
            values.cart = cart.value;
            values.container_no = container_no.value.value;
            values.mbl_date = formattedDate(mbl_date.value.value);
            values.hbl_no = hbl_no.value.value;
            values.mbl_no = mbl_no.value.value;
            values.from_port_id = from_port_id.value.value;
            values.to_port_id = to_port_id.value.value;
            values.warehouse_id = warehouse_id.value.value;

            store.dispatch("saveUpdateInvSalesInvoiceDelivery", values)
            .then((response) => {
                resetForm();
                    buttonText.value = "Save";
                    cart.value = [];
                    toast.success(response.data.message, {
                        timeout: 3000,
                    });
                    setTimeout(() => {
                        router.push({ name: "sale-delivery-records" });
                    }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            submitForm,
            invoice_delivery_master_id,
            product_id,
            customer_id,
            shipment_mode,
            from_port_id,
            to_port_id,
            rate_id,
            currency_rate,
            discount_value,
            discount_method,
            discount_amount,
            tax_amount,
            tax_value,
            tax_type,
            tax_method,
            vat_amount,
            vat_value,
            vat_type,
            vat_method,
            total,
            paid,
            due,
            sales_by,
            commodity,
            container_no,
            mbl_date,
            hbl_no,
            mbl_no,
            supplier_id,
            delivery_date,
            remarks,
            cart,
            requsition_by,
            requsition_by_mobile,
            sale_order_master_id,
            requsition_by_email,
            pr_status,
            status,
            errorMessages,
            // employee_id,
            department_id,
            warehouse_id,
            buttonText,
            loading,
            addDetailRow,
            removeDetailRow,
            validateDetailField,
            getDetailError,
            validateAllDetails,
            calculateRow,
           
        };
    },
    mounted() {
        this.pr_status.value.value = "1";
        this.status.value.value = 1;
        // this.employee_id.value.value = "";
        let user = this.$store.getters.getAuthUser;
        this.requsition_by.value.value = this.$store.getters.getAuthUser.full_name;
        this.requsition_by_mobile.value.value = this.$store.getters.getAuthUser.mobile;
        this.requsition_by_email.value.value = this.$store.getters.getAuthUser.email;

        // Set require_date to today
        const today = new Date().toISOString().slice(0, 10);

         const orderId = this.$route.query.order_id;
       
        if(orderId) {
            this.loading = true;
            this.$watch(() => this.getSaleOrderList,
                (list) => {
                    if (list && list.length > 0) {
                        const match = list.find(i => String(i.id) === String(orderId));
                        if (match) {
                            this.sale_order_master_id.value.value = Number(orderId);
                            this.onSaleInvoiceChange(Number(orderId));
                        }
                    }
                },
                { immediate: true }
            );
            this.loading = false;
        }


        const id = this.$route.query.id;
        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                .dispatch("getInvSalesInvoiceDeliveryById", id)
                .then((data) => {
                    this.isEntryMode = false;
                    this.requisitionDisable = true;
                    let requisition = data;
                    this.invoice_delivery_master_id.value.value = requisition.id;
                    this.sale_order_master_id.value.value = requisition.sale_order_master_id;
                    this.delivery_date.value.value = requisition.delivery_date ? new Date(requisition.delivery_date) : new Date();
                    // this.warehouse_id.value.value = requisition?.warehouse?.id || null;
                    this.pr_status.value.value = requisition.pr_status || "1";
                    // this.customer_id.value.value = requisition.customer_id;
                    // this.buyer_phone.value.value = requisition.buyer_phone;
                    this.shipment_mode.value.value = requisition.shipment_mode;
                    // this.payment_mode.value.value = requisition.payment_mode;

                    this.from_port_id.value.value = requisition.from_port_id;
                    this.to_port_id.value.value = requisition.to_port_id;
                    // this.rate_id.value.value = requisition.rate_id;
                    this.currency_rate.value.value = requisition.currency_rate;
                    // this.sales_by.value.value = requisition.sales_by;

                    this.commodity.value.value = requisition.commodity;
                    this.supplier_id.value.value = requisition.supplier_id;
                    this.container_no.value.value = requisition.container_no,
                    this.mbl_date.value.value = requisition.mbl_date,
                    this.hbl_no.value.value = requisition.hbl_no,
                    this.mbl_no.value.value = requisition.mbl_no,

                    // this.discount_method.value.value = requisition.discount_method;
                    // this.discount_value.value.value = this.discount_method.value.value == 'percent'? requisition.discount_value + '%' : requisition.discount_value;

                    // this.tax_method.value.value = requisition.tax_method;
                    // this.tax_value.value.value = this.tax_method.value.value == 'percent'? requisition.tax_value + '%' : requisition.tax_value;
                    // this.taxType = requisition.tax_type;

                    // this.vat_method.value.value = requisition.vat_method;
                    // this.vat_value.value.value = this.vat_method.value.value == 'percent'? requisition.vat_value + '%' : requisition.vat_value;
                    // this.vatType = requisition.vat_type;

                    // this.paid.value.value = requisition.paid;
                    // this.due.value.value = requisition.due;

                    this.status.value.value = requisition.status || 1;
                    this.product_id.value.value = null;
                    this.cart = [];

                    const uniqueSaleOrderIds = [...new Set(
                        (requisition.details || []).map(detail => detail?.sale_order?.id)
                    )];

                    this.sale_order_master_id.value.value = uniqueSaleOrderIds;

                    // Insert items one by one
                    (requisition.details || []).forEach((item) => {
                        this.cart.push({
                            product_id: item.product_id,
                            category: item?.sale_order_detail?.category || "",
                            calc_type: item?.sale_order_detail?.calc_type || "",
                            height: item?.sale_order_detail?.height || 0,
                            width: item?.sale_order_detail?.width || 0,
                            length: item?.sale_order_detail?.length || 0,
                            cbm_meas: item?.sale_order_detail?.cbm_meas || "",
                            cbm: item?.sale_order_detail?.cbm || "",
                            order_qty: item?.sale_order_detail?.qty || 0,
                            qty: item.qty ?? 0,
                            remaining_qty: +item.remaining_qty || 0,
                            already_delivered_qty: item.already_delivered_qty,
                            product_qty: item.product_qty || 0,
                            rate: item?.sale_order_detail?.rate || "",
                            total: item?.sale_order_detail?.total || "",
                            remarks: item.remarks,
                            sale_order_master_id: item?.sale_order_master_id || null,
                            sale_order_detail_id: item?.sale_order_detail_id || null,
                            order_no: item?.sale_order?.code || "",
                            challan_no: item?.challan_no || "",
                            receive_no: item?.receive_no || "",
                            receive_date: item?.receive_date || "",
                            customer_id: item?.sale_order?.customer_id || null,
                            shipment_mode: item?.sale_order?.shipment_mode || null,
                            supplier_id: item?.sale_order?.supplier_id || null,
                            commodity: item?.commodity || "",
                        });
                    });
                    
                    this.remarks.value.value = requisition.remarks ? requisition.remarks : "";
                    this.$store.commit("UNSET_LOADING");
                })
                .catch((error) => {
                    this.$store.commit("UNSET_LOADING");
                    console.error("Failed to fetch requisition:", error);
                });
            });
        } else {
            this.delivery_date.value.value = new Date();
            this.isEntryMode = true;
        }
    },
};
</script>
